export default __webpack_public_path__ + "assets/technology.432c8f.png";